import apiClient from './apiClient';

const companyUserAPI = {
  getAllUsers: (params = {}) => {
    // Construct query parameters
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.company_id) queryParams.append('company_id', params.company_id);
    
    const queryString = queryParams.toString();
    return apiClient.get(`/company/user/index${queryString ? '?' + queryString : ''}`);
  },
  // getUser: (userId) => apiClient.get(`/company/user/${userId}?company_id=${localStorage.getItem('company_id')}`),
  getUser: (userId) => apiClient.get(`/company/user/show/${userId}`),
  createUser: (userData) => apiClient.post(`/company/user/store?company_id=${localStorage.getItem('company_id')}`, userData),
  updateUser: (userId, userData) => apiClient.post(`/company/user/update/${userId}?company_id=${localStorage.getItem('company_id')}`, userData),
  deleteUser: (userId) => apiClient.delete(`/company/user/delete/${userId}?company_id=${localStorage.getItem('company_id')}`),
};

export default companyUserAPI;